import React from 'react';

const icons = {
  'arrow-right': 'M9.707 13.707l5-5c0.391-0.39 0.391-1.024 0-1.414l-5-5c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l3.293 3.293h-9.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h9.586l-3.293 3.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.391 0.391 1.024 0.391 1.414 0z'
};

const Icon = props => (
<svg className="arrow-icon" width="16" height="16" viewBox="0 0 16 16">
    <path fill="#FFF" d={icons[props.icon]}></path>
</svg>
);

export default Icon;


// WEBPACK FOOTER //
// ./src/components/Icon.js